<template>
  <Toast />

  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Configuración</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Parámetros del Sistema</span>
    </li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-900">Administrar Parámetros</div>
        <p class="mt-2 text-600">Active o desactive las funcionalidades del sistema.</p>
      </div>
    </div>

    <div class="mt-2">
      <DataTable
        ref="dtParametros"
        :value="parametros"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="20"
        :filters="buscar"
        :rowHover="true"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[20, 100, 500, 1000]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Productos"
        responsiveLayout="scroll"
        stripedRows
        showGridlines
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="buscar['global'].value" placeholder="Buscar parámetro..." />
            </span>
          </div>
        </template>

        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid">
            No existen Parámetros registrados.
          </span>
        </template>

        <Column header="#" style="width: 3rem">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>

        <Column field="codigo" header="CÓDIGO" :sortable="true">
          <template #body="{ data }">
            <span class="font-bold">{{ data.codigo }}</span>
          </template>
        </Column>

        <Column field="nombre" header="NOMBRE" :sortable="true"></Column>

        <Column field="descripcion" header="DESCRIPCIÓN"></Column>

        <Column field="estado" header="ESTADO / ACCIÓN" style="min-width: 150px">
          <template #body="{ data }">
            <div class="flex align-items-center">
              <InputSwitch v-model="data.estado" :true-value="1" :false-value="0" @change="cambiarEstado(data)" />
              <span class="ml-2" :class="data.estado === 1 ? 'text-green-600 font-bold' : 'text-red-600 font-bold'">
                {{ data.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
              </span>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import ParametrosService from '@/service/ParametrosService' // Asegúrate de crear este archivo
import { useAuth } from '@/stores'

export default {
  data() {
    return {
      parametros: [],
      tipo_clientes: [],
      cargando: true,
      buscar: {},
      auth: null,
      parametrosService: null
    }
  },
  created() {
    this.auth = useAuth()
    this.parametrosService = new ParametrosService()
    this.initBuscar()
  },
  mounted() {
    this.cargarParametros()
  },
  methods: {
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      }
    },
    cargarParametros() {
      this.cargando = true
      this.parametrosService
        .getAll()
        .then((data) => {
          this.parametros = data.parametros_sistema || []
          this.tipo_clientes = data.tipo_clientes || []
          this.cargando = false
        })
        .catch((error) => {
          console.error(error)
          this.cargando = false
        })
    },
    // Lógica para cambiar estado al hacer click en el Switch
    cambiarEstado(parametro) {
      const nuevoEstado = parametro.estado // Ya viene cambiado por el v-model

      this.parametrosService
        .updateEstado(parametro.id, nuevoEstado)
        .then((response) => {
          // Verificamos respuesta exitosa (ajusta según tu backend, a veces es response.ok o status 200)
          if (response.status === 200 || response.success) {
            this.$toast.add({
              severity: 'success',
              summary: 'Actualizado',
              detail: `El parámetro ${parametro.codigo} ahora está ${nuevoEstado === 1 ? 'ACTIVO' : 'INACTIVO'}`,
              life: 3000
            })
          } else {
            // Si falló, revertimos el cambio visualmente
            parametro.estado = nuevoEstado === 1 ? 0 : 1
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo actualizar'
            })
          }
        })
        .catch(() => {
          // Error de red, revertimos
          parametro.estado = nuevoEstado === 1 ? 0 : 1
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error de conexión'
          })
        })
    }
  }
}
</script>

<style scoped>
.p-invalid {
  color: red;
}
</style>
